export const SAVE_GAME = 'save-game';
export const INSTANT_IMPORT_DATA = 'instant-import-data';
